import React, { FC, HTMLAttributes } from 'react';

// Building blocks of a booking step, styled by pages/BookingHome/uplift.css (the uplift mockup).

// The white panel a step sits in; its <h2> is the step title.
export const StepPage: FC<HTMLAttributes<HTMLElement>> = ({ children, ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <section className="panel" {...rest}>{children}</section>
);

export const StepLead: FC = ({ children }) => <p className="psub">{children}</p>;

// A section inside a step, headed by a small uppercase label (its direct <h3>).
export const StepSection: FC<HTMLAttributes<HTMLElement>> = ({ children, ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <section className="sect" {...rest}>{children}</section>
);

export const StepError: FC<HTMLAttributes<HTMLParagraphElement>> = ({ children, ...rest }) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <p className="err-msg" {...rest}>{children}</p>
);
